export default "__VITE_ASSET__B5by3rxp__"